import { logging } from 'protractor';
import { Injectable } from '@angular/core';
import { Endpoints } from 'src/app/shared/config/endpoints';
import { HttpClient } from '@angular/common/http';
import { LogActivityTypeModel } from '../../models/log-activity.model';
import { Subject, Observable, of, BehaviorSubject } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import DateUtils from 'src/app/utils/date';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.state';

@Injectable({
  providedIn: 'root'
})

export class LogActivityService {
  public logItem = new BehaviorSubject<any>('');
  private logActivityApi = this.endpoint.analyticsUrl;
  private logActivityTypesApi = this.endpoint.analyticsUrl;
  dateUtil = new DateUtils();
  orgID;
  user;
  teamId;

  constructor(
    private endpoint: Endpoints,
    private http: HttpClient,
    store: Store<AppState>
  ) {
    store.select("userInfo").subscribe((info) => {
      this.orgID = info.organization.id;
      this.user = info.user;
      this.teamId = info.user.teamID;
    });
  }

  private _refreshNeeded$ = new Subject<void>();

  get refreshNeeded$() {
    return this._refreshNeeded$;
  }

  /**
   * Error Handler
   */
  private handleError = (error: any): Observable<any> => {
    let message = "";
    if (error) {
      if (error.error) {
        message = error.error.message;
      } else {
        message = error.message;
      }
    }
    return of(null);
  };

  /**
   * Create Activity Type
   * @param form
   */
  createActivityType(form: LogActivityTypeModel) {
    const body = {
      name: form.name,
      orgID: this.orgID
    }
    return this.http.post(`${this.logActivityTypesApi}/addActivityType`, body).pipe(
      tap(() => {
        this._refreshNeeded$.next();
      })
    );
  }

  /**
  * delete Activity Type
  * @param id
  */
  deleteActivityType(id) {
    return this.http.delete(`${this.logActivityTypesApi}/deleteActivityType/${id}`)
  }

  /**
   * Get Activity Types
   */
  getActivityTypes() {
    try {
      return this.http.get(`${this.logActivityTypesApi}/${this.orgID}/getActivityTypes`)
        .pipe(catchError(this.handleError));
    } catch (e) {
      alert(e);
    }
  }

  getLogActivity(clientId: string) {
    try{
      return this.http.get(`${this.logActivityApi}/getMostRecentActivityLogForClient/${this.orgID}/${clientId}`)
    }catch (error) {
      alert(error)
    }
  }

  getSingleActivityType(id) {
    return this.http.get(`${this.logActivityTypesApi}/${id}/getActivityType`);
  }

  updateActivityType(form: LogActivityTypeModel) {
    const body = {
      id: form.id,
      name: form.name,
      orgID: this.orgID
    }
    return this.http.post(`${this.logActivityTypesApi}/updateActivityType`, body).pipe(
      tap(() => {
        this._refreshNeeded$.next();
      })
    );
  }

  //Activity Logs Starts Here
  /**
   * Create A New Activity Log
   * @param form
   */
  createNewActivityLog(form) {
    const tmpDate = form.date;
    let day = tmpDate.getDate();
    day = day < 10 ? `0${day}` : day;
    let month = tmpDate.getMonth() + 1;
    month = month < 10 ? `0${month}` : month;
    const year = tmpDate.getFullYear();
    const date = `${month}-${day}-${year}`;
    const dateTime = `${date} ${form.time}`;
    const logDate: any = Date.parse(dateTime);
    const body = {
      assigneeID: `${form.userID}`,
      clientID: `${form.clientID || ""}`,
      clientName: `${form.clientName || ""}`,
      content: `${form.content}`,
      dateLogged: `${logDate}`,
      creatorID: `${this.user.id}`,
      dealCode: `${form.dealCode || ""}`,
      dealName: `${form.dealName || ""}`,
      duration: form.duration,
      name: "LOGS",
      orgID: `${this.orgID}`,
      teamID: `${form.teamID}`,
      otherName: `${form.otherName || ""}`,
      otherID: `${form.otherID || ""}`,
      type: `${form.type.name}`,
    }
    return this.http.post(`${this.logActivityTypesApi}/addActivity`, body)
      .pipe(
        tap(() => {
          this._refreshNeeded$.next();
        })
      );
  }

  /**
  * Update Activity Log
  * @param form
  */
  updateActivityLog(form) {
    const body = {
      assigneeID: `${form.assigneeID}`,
      clientID: `${form.clientID || ""}`,
      clientName: `${form.clientName || ""}`,
      content: `${form.content}`,
      createdDate: `${form.createdDate}`,
      creatorID: `${this.user.id}`,
      creatorName: `${form.creatorName}`,
      dateLogged: `${form.dateLogged}`,
      dealCode: `${form.dealCode || ""}`,
      dealName: `${form.dealName || ""}`,
      duration: form.duration,
      id: form.id,
      name: "LOGS",
      orgID: `${this.orgID}`,
      section: "ACTIVITIES",
      otherName: `${form.otherName || ""}`,
      otherID: `${form.otherID || ""}`,
      teamID: `${form.teamID}`,
      type: `${form.type.name || form.type}`,
    }
    return this.http.post(`${this.logActivityApi}/updateActivity`, body).pipe(
      tap(() => {
        this._refreshNeeded$.next();
      })
    );
  }

  /**
   * Fetch All Log Activity
   */
  getActivityLogs(Ids, type) {
    return this.http.get(`${this.logActivityApi}/getActivities/${Ids}/${type}/${this.orgID}`);
  }

  /**
   * Get Activity By
   * @param id
   */
  getSingleActivityLog(id) {
    return this.http.get(`${this.logActivityApi}/getActivity/${id}`);
  }

  fetchByDate(body: { from?: any, to?: any, type?: any; teamID?: any, userID?: any }) {
    if (!body) return;
    const { from, to, type, teamID, userID } = body
    const payload = {
      createdDateFrom: `${from - 1}`,
      createdDateTo: `${to + 1}`,
      orgID: `${this.orgID}`,
      type: type,
      userID: userID || teamID || [this.user.id]
    }
    return this.http.post(`${this.logActivityApi}/getActivityLogsForReport`, payload);
  }

}
